import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const AuthRedirectHandler = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, user, isInitializing, profile } = useAuth();
  useEffect(() => {
    // Only run redirect logic after auth initialization is complete
    if (!isInitializing && isAuthenticated && user) {
      const currentPath = location.pathname;
      
      console.log('AuthRedirectHandler - Current path:', currentPath);
      console.log('AuthRedirectHandler - Profile:', profile);
      console.log('AuthRedirectHandler - User:', user?.email);
      
      // The auth provider has already loaded the profile before initialization
      // completes, so redirecting does not need an additional fixed delay.
      if (profile) {
        const hasRequiredInfo = profile.age && profile.name;
          
        console.log('AuthRedirectHandler - Has required info:', hasRequiredInfo);
          
        if (hasRequiredInfo) {
          // User has completed profile and should be on home screen
          if (currentPath === '/onboarding') {
            console.log('AuthRedirectHandler - Redirecting completed user to home');
            navigate('/', { replace: true });
          }
        } else {
          // User needs to complete their profile
          if (currentPath !== '/onboarding') {
            console.log('AuthRedirectHandler - Redirecting incomplete user to onboarding');
            navigate('/onboarding', { replace: true });
          }
        }
      } else if (currentPath !== '/onboarding') {
        console.log('AuthRedirectHandler - No profile found, redirecting to onboarding');
        navigate('/onboarding', { replace: true });
      }
    }
  }, [isInitializing, isAuthenticated, user, profile, navigate, location.pathname]);

  return children;
};

export default AuthRedirectHandler;
